import script from "./InvestSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestSummary.vue?vue&type=script&setup=true&lang=ts"

import "./InvestSummary.vue?vue&type=style&index=0&id=5eda3ef1&scoped=true&lang=css"
script.__scopeId = "data-v-5eda3ef1"

export default script